import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerFatturaElettronicaModalComponent } from './worker-fattura-elettronica-modal';

export const WorkerFatturaElettronicaModalModule: string = ng
    .module('worker-fattura-elettronica-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerFatturaElettronicaModalComponent', WorkerFatturaElettronicaModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-fattura-elettronica-modal/worker-fattura-elettronica-modal.module.ts